import { Box, Switch, styled } from "@mui/material";
import React, { useContext, useState } from "react";
import { CThemeContext } from "../../../../context/ThemeContext";

const ToggleWrapper = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "0.5em",
  padding: "0.125em",

  fontSize: "1.5em",
  position: "relative",
  height: "1.5em",
});

const ToggleSwitch = styled(Switch)(({ theme }) => ({
  padding: "0.2em",
  width: "3em",
  height: "1.2em",
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 0,
    "&.Mui-checked": {
      transform: "translateX(1.9em)",
      "& + .MuiSwitch-track": {
        backgroundColor: "#dfdfdf",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: "1.1em",
    height: "1.1em",
    backgroundColor: "var(--c-dark-bg-color)",
    boxShadow:
      "inset 0 -1px 1px rgba(0, 0, 0, 0.1), inset 0 -2px 1px rgba(0, 0, 0, 0.2), inset 0 3px 1px rgba(255, 255, 255, 0.3), 0 2px 2px rgba(0, 0, 0, 0.5)",
  },
  "& .MuiSwitch-track": {
    borderRadius: "0.375em",
    backgroundColor: "#181818",
    boxShadow:
      "inset 0 0 1px 2px rgba(255, 255, 255, 0.2), inset 0 1px 2px rgba(0, 0, 0, 0.4)",
    transition: "background-color 0.4s linear",
  },
}));

const Toggle = () => {
  const { isDark, setTheme } = useContext(CThemeContext);
  const [anim, setChecked] = useState(true);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTheme(event.target.checked ? "dark" : "light");
    setChecked(false);
    setTimeout(() => {
      setChecked(true);
    }, 500);
    document.documentElement.style.setProperty(
      "--c-bg-color",
      isDark ? "var(--c-light-bg-color)" : "var(--c-dark-bg-color)"
    );
    document.documentElement.style.setProperty(
      "--c-bg-content-color",
      isDark
        ? "var(--c-light-bg-content-color)"
        : "var(--c-dark-bg-content-color)"
    );
    document.documentElement.style.setProperty(
      "--c-text-color",
      isDark ? "var(--c-light-text-color)" : "var(--c-dark-text-color)"
    );
  };

  return (
    <>
      <Box
        sx={{
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          pointerEvents: "none",
          position: "fixed",
          zIndex: 1000,
          backdropFilter: anim ? "blur(0px)" : "blur(5px)",
          transition: "backdrop-filter .2s ease-in-out", // затримка 2 секунди для backdropFilter
        }}
      />
      <ToggleWrapper
        sx={{
          backgroundImage: !isDark
            ? "linear-gradient(to bottom, var(--c-light-bg-color), var(--c-light-bg-color))"
            : "linear-gradient(to bottom, var(--c-dark-bg-content-color), var(--c-dark-bg-color))",
          boxShadow: !isDark
            ? "inset 0 0 1px 2px rgba(255, 255, 255, 0.2), inset 0 1px 2px rgba(0, 0, 0, 0.4)"
            : "inset 0 0 1px 2px rgba(0, 0, 0, 0.4), inset 0 1px 2px rgba(255, 255, 255, 0.2)",
          "& .MuiSwitch-thumb": {
            backgroundColor: isDark
              ? "var(--c-dark-bg-content-color)"
              : "var(--c-light-bg-content-color)",
          },
        }}
      >
        <ToggleSwitch checked={isDark} onChange={handleChange} />
      </ToggleWrapper>
    </>
  );
};

export default Toggle;
